import { useEffect, useState } from "react";

const API = "https://pax-ordinis-app-db9z.vercel.app/api";

export default function Today(){

const [orientation,setOrientation]=useState("");
const [returnText,setReturnText]=useState("");
const [rule,setRule]=useState({});
const [saveStatus,setSaveStatus]=useState("");
const [loaded,setLoaded]=useState(false);


/* FORMAT TIME */

function formatSavedTime(){

const now=new Date();

return(
"Saved "+
now.toLocaleDateString("en-US",{month:"short",day:"numeric"})+
", "+
now.toLocaleTimeString("en-US",{hour:"2-digit",minute:"2-digit"})
);

}


/* LOAD RULE */

useEffect(()=>{

const token=localStorage.getItem("token");

if(!token) return;

fetch(API+"/daily-rule",{

headers:{
Authorization:"Bearer "+token
}

})
.then(res=>res.json())
.then(data=>{

setRule(data || {});

setOrientation(data.orientation || "");
setReturnText(data.return_text || "");

setLoaded(true);

});

},[]);



/* SAVE RULE */

function saveRule(){

if(!loaded) return;

const token=localStorage.getItem("token");

if(!token) return;

setSaveStatus("Saving...");


const updatedRule={

...rule,

orientation:orientation,

return_text:returnText,

/* PRESERVE EVENING DATA */

examen_checkboxes: rule.examen_checkboxes || {},

examen_text_1: rule.examen_text_1 || "",

examen_text_2: rule.examen_text_2 || "",

examen_text_3: rule.examen_text_3 || ""

};


fetch(API+"/daily-rule",{

method:"POST",

headers:{
"Content-Type":"application/json",
Authorization:"Bearer "+token
},

body:JSON.stringify(updatedRule)

})

.then(()=>{

setRule(updatedRule);

setSaveStatus(formatSavedTime());

})

.catch(()=>{

setSaveStatus("Offline");

});

}



/* UI */

return(

<div className="today-space">

<div className="today-date">

{new Date().toLocaleDateString("en-US",{
month:"long",
day:"numeric",
year:"numeric"
}).toUpperCase()}

</div>


<div className="today-day">

{new Date().toLocaleDateString("en-US",{
weekday:"long"
})}

</div>


<div className="daily-rule-card">


<div className="card-title">

Daily Rule

</div>


<div>

Orientation

</div>


<textarea

className="card-textarea"

placeholder="An intention for this day..."

value={orientation}

onChange={(e)=>setOrientation(e.target.value)}

onBlur={saveRule}

/>


<div className="rule-sections">

Interior Awareness  
Discernment  
Self-Regulation  
Rhythm  
The Body  
Work and Responsibility  
Relationships  
Reflection and Examination

</div>


<div>

Return

</div>


<textarea

className="card-textarea"

placeholder="A closing thought..."

value={returnText}

onChange={(e)=>setReturnText(e.target.value)}

onBlur={saveRule}

/>


<div style={{

marginTop:"10px",

fontSize:"12px",

opacity:0.6

}}>

{saveStatus}

</div>


</div>

</div>

);

}
